// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class ExtEnrollmentCommTypeUpdateRequestModel {
    static getAttributeTypeMap() {
        return ExtEnrollmentCommTypeUpdateRequestModel.attributeTypeMap;
    }
}
ExtEnrollmentCommTypeUpdateRequestModel.discriminator = undefined;
ExtEnrollmentCommTypeUpdateRequestModel.additionalProperties = false;
ExtEnrollmentCommTypeUpdateRequestModel.attributeTypeMap = [
    {
        "name": "memberNumber",
        "baseName": "memberNumber",
        "type": "string"
    },
    {
        "name": "communicationTypes",
        "baseName": "communicationTypes",
        "type": "TCSCommunicationType"
    },
    {
        "name": "marketingCommunicationTypes",
        "baseName": "marketingCommunicationTypes",
        "type": "TCSCommunicationType"
    },
];
//# sourceMappingURL=extEnrollmentCommTypeUpdateRequestModel.js.map